import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    CircularProgress,
    Typography, TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchTrashedDoctors, restoreDoctor } from "../../Adapters/ApiAdapter";

const RestoreDoctors = () => {
    const [doctors, setDoctors] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [restoringId, setRestoringId] = useState(null);

    useEffect(() => {
        const loadDoctors = async () => {
            try {
                const response = await fetchTrashedDoctors();
                if (response?.data) {
                    setDoctors(response.data);
                } else {
                    toast.error("Failed to fetch trashed doctors.");
                }
            } catch (err) {
                toast.error("Error fetching trashed doctors.");
            } finally {
                setLoading(false);
            }
        };

        loadDoctors();
    }, []);

    const handleRestore = async (id) => {
        setRestoringId(id);
        try {
            const response = await restoreDoctor(id);
            if (response?.status === "true") {
                setDoctors((prev) => prev.filter((doc) => doc.id !== id));
                toast.success("Doctor restored successfully!");
            } else {
                toast.error("Failed to restore doctor.");
            }
        } catch (err) {
            toast.error("Error restoring doctor.");
        } finally {
            setRestoringId(null);
        }
    };

    // Filtered doctors based on search input
    const filteredDoctors = doctors.filter((doc) =>
        doc.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const columns = [
        { field: "id", headerName: "ID", width: 80 },
        { field: "name", headerName: "Name", width: 200 },
        {
            field: "speciality",
            headerName: "Specialty",
            width: 200,
            valueGetter: (params) => params.row.speciality?.join(", ") || "-",
        },
        {
            field: "department",
            headerName: "Department",
            width: 200,
            valueGetter: (params) => params.row.speciality?.join(", ") || "-",
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 150,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => handleRestore(params.row.id)}
                    disabled={restoringId === params.row.id}
                >
                    {restoringId === params.row.id ? "Restoring..." : "Restore"}
                </Button>
            ),
        },
    ];

    return (
        <Box m={3}>
            <ToastContainer />
            <Typography variant="h4" gutterBottom>
                Restore Doctors
            </Typography>
            <Box mb={2}>
                <TextField
                    label="Search by Name"
                    variant="outlined"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </Box>

            {loading ? (
                <CircularProgress />
            ) : (
                <DataGrid rows={filteredDoctors} columns={columns} autoHeight pageSize={5} />
            )}
        </Box>
    );
};

export default RestoreDoctors;